import ITask from '../../../Utility/Task/ITask';
import CardSystem from '../CardSystem';

export class PlayInitialCardTask implements ITask<CardSystem> {
    * execute(system: CardSystem) {
        const cardsInStack = system.getCardsInStack();
        const inStack = system.store.getState().levelState.cardsState.inStack;

        if (cardsInStack.length === 0) return;

        const topCardID = inStack[cardsInStack.length - 1];
        system.playCard(topCardID);
    }
}
